var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/Search/Tags.tsx";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import { sample } from 'effector';
import { useStore } from 'effector-react';
import { Chip, LongText } from '@gmini/ui-kit';
import { assertNever } from '@gmini/utils';
import * as viewerSelect from "../../forge-viewer/model/selectModel";
import { getBimNode } from "./utils";
import { createSearchNodeModel } from "./SearchStore";
import { executeNodeSearchPending } from "./search.model";
import { TagLabelWrapper, TagsWrapper } from "./Tags.styled";
import { IsolateButton } from "./IsolateButton";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function createSearchModel(_ref) {
  var nodes$ = _ref.nodes$,
      tree$ = _ref.tree$,
      currentEntity$ = _ref.currentEntity$,
      searchInDynamicGroups = _ref.searchInDynamicGroups;
  var searchModel = createSearchNodeModel({
    nodes$: nodes$,
    tree$: tree$,
    currentEntity$: currentEntity$,
    searchInDynamicGroups: searchInDynamicGroups
  });
  sample({
    ɔ: [{
      clock: searchModel.setSearchNodes,
      fn: function fn(searchNodes) {
        if ((searchNodes === null || searchNodes === void 0 ? void 0 : searchNodes.type) === 'filter') {
          viewerSelect.changeViewerMode('Isolate');
        }
      }
    }],
    config: {
      sid: "ecue9l"
    }
  });
  var Tags = /*#__PURE__*/React.memo(function (_ref2) {
    var _searchNodes$nodes;

    var dataTestIdFor = _ref2.dataTestIdFor;
    var searchNodes = useStore(searchModel.searchNodes$, {
      loc: {
        file: _effectorFileName,
        line: 47,
        column: 24
      },
      name: "Tags",
      sid: "Tags /src/classifier-editor/Search/Tags.tsx [47, 24]"
    });
    var pending = useStore(executeNodeSearchPending, {
      loc: {
        file: _effectorFileName,
        line: 48,
        column: 20
      },
      name: "Tags",
      sid: "Tags /src/classifier-editor/Search/Tags.tsx [48, 20]"
    });
    React.useEffect(function () {
      return function () {
        searchModel.resetSearchNodes();
      };
    }, []);
    var bimNodes = searchNodes === null || searchNodes === void 0 ? void 0 : (_searchNodes$nodes = searchNodes.nodes) === null || _searchNodes$nodes === void 0 ? void 0 : _searchNodes$nodes.map(function (_ref3) {
      var node = _ref3.node;
      return getBimNode(node, nodes$.getState());
    });

    if (!searchNodes) {
      return null;
    }

    var chipLabel = '';
    var searchBimNodeCount = (bimNodes === null || bimNodes === void 0 ? void 0 : bimNodes.filter(Boolean).length) || 0;
    var searchType = searchNodes.type;

    switch (searchType) {
      case 'search':
        {
          if (searchBimNodeCount === 1) {
            var _bimNodes$;

            chipLabel = (bimNodes === null || bimNodes === void 0 ? void 0 : (_bimNodes$ = bimNodes[0]) === null || _bimNodes$ === void 0 ? void 0 : _bimNodes$.name) || '';
            break;
          }

          chipLabel = "\u041D\u0430\u0439\u0434\u0435\u043D\u043E ".concat(searchBimNodeCount);
          break;
        }

      case 'filter':
        {
          chipLabel = searchBimNodeCount > 0 ? "\u041D\u0430\u0439\u0434\u0435\u043D\u043E ".concat(searchBimNodeCount) : '';
          break;
        }

      default:
        {
          return assertNever("Unexpected search type", searchType);
        }
    }

    return /*#__PURE__*/_jsxs(TagsWrapper, {
      children: [/*#__PURE__*/_jsx(Chip, {
        dataTestIdFor: {
          root: dataTestIdFor === null || dataTestIdFor === void 0 ? void 0 : dataTestIdFor.root,
          deleteIcon: dataTestIdFor === null || dataTestIdFor === void 0 ? void 0 : dataTestIdFor.deleteIcon
        },
        label: /*#__PURE__*/_jsx(TagLabelWrapper, {
          children: /*#__PURE__*/_jsx(LongText, {
            withoutRightText: true,
            partSize: 20,
            children: chipLabel
          })
        }),
        loading: pending,
        onDelete: searchModel.resetSearchNodes
      }), searchNodes.type === 'filter' ? /*#__PURE__*/_jsx(IsolateButton, {
        isolated: searchNodes.isolated,
        isolate: searchModel.isolate
      }) : null]
    });
  });
  Tags.displayName = 'Tags';
  return {
    searchModel: searchModel,
    Tags: Tags
  };
}